<div *ngIf="!hideHeader">
  <div *ngIf="isMobile; else webLogin">
    <div class="mobile-header">
      <div class="mobile-title"  *ngIf="!renderDashboardTitle">
        P2P Bidding
      </div>
      <div class="dashboard-title"  *ngIf="renderDashboardTitle">
        P2P Energy Trading Dashboard
      </div>
      <app-profile></app-profile>
    </div>
  </div>

  <ng-template #webLogin>
    <div class="header">
      <img (click)="navigateTo('/')" class="img logo" src="assets/logo_transparent.png" />
      <div class="title">Peer to Peer Solar Energy Trading</div>
      <app-profile></app-profile>
    </div>
  </ng-template>
</div>

<main class="main-content">
  <router-outlet></router-outlet>
</main>
